"use client";

import Image from "next/image";
import { motion } from "framer-motion";
import SectionTitle from "../SectionTitle";
import { IAward } from "@/data/awards";

interface Props {
  awards: IAward[];
}

const AwardSection: React.FC<Props> = ({ awards }) => {
  return (
    <section
      id="awardsandnews"
      className="scroll-mt-32 relative z-10 bg-gradient-to-t from-[#e8eee7] to-[#c0dab8] py-20 overflow-hidden"
    >
      <div className="container mx-auto flex flex-col gap-16 px-6">
        {awards.map((award, index) => (
          <motion.div
            key={index}
            className="backdrop-blur-xl bg-white/30 rounded-2xl shadow-md p-6 md:p-10 border border-white/30 relative z-20 flex flex-col lg:flex-row items-center justify-between gap-10"
            initial={{ opacity: 0, y: 80 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, type: "spring", bounce: 0.25 }}
            viewport={{ once: true }}
          >
            {/* Text section */}
            <div className="max-w-xl flex flex-col justify-between">
              <div>
                <SectionTitle>
                  <h2 className="text-primary mb-6 text-2xl md:text-3xl font-bold leading-tight text-left">
                    {award.title}
                  </h2>
                </SectionTitle>
                <h3 className="text-lg mt-2 font-semibold text-foreground">
                  {award.subtitle}
                </h3>
                <p className="mt-4 text-base md:text-lg text-foreground-accent">
                  {award.description}
                </p>
              </div>

              <div className="mt-10 flex items-center gap-3 text-sm text-foreground-accent">
                <Image
                  src="/images/sif-logo.jpeg"
                  alt="Singapore International Foundation logo"
                  width={24}
                  height={24}
                  className="object-contain"
                />
                <span className="text-left">
                  Award issued by the Singapore International Foundation
                </span>
              </div>
            </div>

            {/* Image section */}
            <div className="flex justify-center">
              <Image
                src={award.imageSrc}
                alt={award.title}
                width={300}
                height={300}
                className="rounded-xl shadow-xl"
                priority
              />
            </div>
          </motion.div>
        ))}
      </div>

      {/* Glowing background elements */}
      <div className="absolute top-10 left-20 w-96 h-96 bg-white opacity-10 rounded-full blur-2xl z-0 animate-pulse hidden md:block"></div>
      <div className="absolute top-10 right-10 w-64 h-64 bg-white opacity-10 rounded-full blur-2xl z-0 animate-pulse hidden md:block"></div>
      <div className="absolute bottom-10 right-20 w-96 h-96 bg-primary opacity-10 rounded-full blur-2xl z-0 animate-pulse hidden md:block"></div>
      <div className="absolute bottom-10 left-10 w-64 h-64 bg-primary opacity-10 rounded-full blur-2xl z-0 animate-pulse hidden md:block"></div>
    </section>
  );
};

export default AwardSection;
